<template>
  <div class="full-loading d-flex justify-content-center align-items-center">
    <b-spinner
      type="grow"
      :label="$tc('global.spinner.loading')"
      variant="primary"
    />
  </div>
</template>

<script>
export default {
    name: 'VtLoading',
    components: { }
}

</script>

<style scoped>

  .full-loading{
    z-index: 15000;
    width: 100%;
    height: 100%;
    position: absolute;
  }

</style>
